
import React from "react";

// reactstrap components
import { Row, Col, Container } from "reactstrap";
import { useTranslation } from 'react-i18next';
function DemoFooter() {
  const { t, i18n } = useTranslation();
  return (
    <footer className="footer footer-black footer-white">
      <Container>
        <Row>
          <Col md="5" />
          <Col md="3" >
            <div>
              <span className="copyright">
                © {new Date().getFullYear()}, {t('Footer')}
              </span>
            </div>
          </Col>
          <Col md="4" />
        </Row>
      </Container>
    </footer>
  );
}

export default DemoFooter;
